<div class="table_dots_box">
  <div class="option" [style]="'color: ' + option?.color" *ngFor="let option of options" (click)="select(option)">
    <ion-icon *ngIf="option.icon" [name]="option.icon"></ion-icon>
    <div *ngIf="option.name" class="name">{{translatePath + option.name | translate: {default: option.name} }}</div>
  </div>
</div>